import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import logoSmall from 'src/assets/logo/safi-swap-logo.webp';

const Logo = ({ width = 30, sx = {}, small = true }) => {
  // SMALL → icon only
  if (small) {
    return (
      <Box
        component="img"
        src={logoSmall}
        alt="SafiSwap logo"
        sx={{
          width,
          display: 'block',
          ...sx,
        }}
      />
    );
  }

  // LARGE → icon + text
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        ...sx,
      }}
    >
      <Box
        component="img"
        src={logoSmall}
        alt="SafiSwap logo"
        sx={{
          width,
          display: 'block',
        }}
      />

      <Typography
        variant="h5"
        fontWeight={900}
        letterSpacing={0.5}
        color="text.primary"
        sx={{ lineHeight: 1 }}
      >
        SafiSwap
      </Typography>
    </Box>
  );
};

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object,
  small: PropTypes.bool,
};

export default Logo;
